import "./index.scss";
import "./i18n/i18n";
import "font-awesome/css/font-awesome.min.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-datepicker/dist/react-datepicker.css";
import "simplebar-react/dist/simplebar.min.css";
import "rc-tree-select/assets/index.css";
import ReactDOM from "react-dom/client";
import App from "./App";
import store from "./store";
import reportWebVitals from "./reportWebVitals";
import React from "react";
import { Provider } from "react-redux";
import { registerLicense } from "@syncfusion/ej2-base";

registerLicense(process.env.REACT_APP_SYNCFUSION_LICENSE_KEY);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <App />
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
